import React from 'react'
// libs
import { useSelector } from 'react-redux'
// types
import { FieldType, IField } from 'types/graphql'
// store
import { objectEntitiesSelector } from 'store/reducers/objectEntities'

const PLAN_ENTITY_API_NAMES = ['actions', 'kpis', 'objectives']

const FIELD_NAMES_TO_EXCLUDE = ['plan', 'recurrence', 'resultTarget']

const STANDARD_FIELD_NAMES_TO_INCLUDE = [
  'completionPercentage',
  'membersUserPosition',
  'status',
  'description',
  'completionAt',
  'actualCompletionDate',
  'commencementAt',
  'ownedByEmployeeOrPosition'
]

export const FIELD_TYPES_TO_EXCLUDE = [
  FieldType.RiskMatrix,
  FieldType.Table,
  FieldType.DocumentOrLink,
  FieldType.Section,
  FieldType.Label,
  FieldType.InjuryMasterLinks,
  FieldType.InjuryMasterParentLinks
]

const GENERAL_SECTION = 'General'

export type PlanFilterField = IField & { multiple: boolean; entityName: string }

export const usePlanFilterFields = (search?: string) => {
  const entities = useSelector(objectEntitiesSelector)

  const fields = React.useMemo((): PlanFilterField[] => {
    const planEntities = entities.filter((e) => PLAN_ENTITY_API_NAMES.includes(e.apiName))

    const seenStandard = new Set<string>()
    const generalFields: PlanFilterField[] = []
    const fieldsByEntity: PlanFilterField[] = []

    for (const entity of planEntities) {
      const reviewFieldIds = entity.reviewFieldIds || []

      for (const field of entity.fields || []) {
        if (!field || FIELD_TYPES_TO_EXCLUDE.includes(field.fieldType)) {
          continue
        }
        if (FIELD_NAMES_TO_EXCLUDE.includes(field.name)) {
          continue
        }
        if (reviewFieldIds.includes(field.id)) {
          continue
        }
        if (search && !field.label?.toLowerCase().includes(search.toLowerCase())) {
          continue
        }

        if (field.standard && STANDARD_FIELD_NAMES_TO_INCLUDE.includes(field.name)) {
          if (!seenStandard.has(field.name)) {
            seenStandard.add(field.name)
            generalFields.push({ ...field, multiple: false, entityName: GENERAL_SECTION })
          }
        } else {
          fieldsByEntity.push({ ...field, multiple: false, entityName: entity.name })
        }
      }
    }

    return [...generalFields, ...fieldsByEntity]
  }, [entities, search])

  return { fields }
}
